export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0013_thumb.37856fc9.jpg";